import { T } from "@/locales";

export const columns = [
  {
    title: T("序号"),
    dataIndex: "index",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("货品名称"),
    dataIndex: "material_name",
  },
  {
    title: T("货品编号"),
    dataIndex: "material_number",
  },
  {
    title: T("容器编号"),
    dataIndex: "pallet_number",
  },
  {
    title: T("序列号"),
    dataIndex: "serial_number",
  },
  {
    title: T("批次编号"),
    dataIndex: "batch_number",
  },
  {
    title: T("收货数量"),
    dataIndex: "receipt_quantity",
  },
  {
    title: T("收货重量(吨)"),
    dataIndex: "total_weight",
  },
  {
    title: T("收货面积(平方米)"),
    dataIndex: "total_area",
  },
  {
    title: T("收货体积(立方米)"),
    dataIndex: "total_volume",
  },
  {
    title: T("运输计费单位"),
    dataIndex: "transport_charge_unit_display",
    module: "finance",
  },
  {
    title: T("运输单价"),
    dataIndex: "transport_unit_price",
    module: "finance",
  },
  {
    title: T("运输费用"),
    dataIndex: "transport_amount",
    module: "finance",
  },
  {
    title: T("装卸计费单位"),
    dataIndex: "handling_charge_unit_display",
    module: "finance",
  },
  {
    title: T("装卸单价"),
    dataIndex: "handling_unit_price",
    module: "finance",
  },
  {
    title: T("装卸费用"),
    dataIndex: "handling_amount",
    module: "finance",
  },
  {
    title: T("单位"),
    dataIndex: "material_unit",
  },
  // {
  //   title: T("计费量"),
  //   dataIndex: "charge_value",
  //   key: "charge_value",
  // },
  // {
  //   title: T("计费单位"),
  //   dataIndex: "charge_unit",
  //   key: "charge_unit",
  // },
  {
    title: T("质检状态"),
    dataIndex: "status_display",
    key: "quality_inspection_status",
  },
  {
    title: T("生产日期"),
    dataIndex: "production_date",
  },
];
